"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var css = _interopRequireWildcard(require("./Divider.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * A divider is a thin line that groups content in lists and layouts. All
 * properties supplied, such as HTML attributes or aria tags, are added to the
 * root `<hr>` element.
 *
 * By default, dividers are considered a feature of visual layout, and are
 * hidden from screen-readers. In the rare event that a divider must be
 * announced by a screen-reader, you may set `aria-hidden` to false, and
 * provide an accessible label via the `aria-label` attribute.
 *
 * To test this, try configuring the Divider as described, turn on your
 * screen-reader and inspect the rendered divider.
 */
const Divider = ({
  'aria-hidden': ariaHidden = true,
  color = 'ui4',
  ...otherProps
}) => (0, _pragma.createFelaElement)("hr", _extends({
  "aria-hidden": ariaHidden,
  css: css.root,
  cssProps: {
    color
  }
}, otherProps));

Divider.displayName = 'Divider';
var _default = Divider;
exports.default = _default;
//# sourceMappingURL=Divider.js.map